export const ApiKey = "b41d8378d8be38b87e183995a2c381d1";
export const WeatherIcons = 'http://openweathermap.org/img/wn/';